//services/ LoginService.js
import UserModel from "../models/UserModel";
import { base_url } from "../utils/constante";


// Sauvegarde de la session créateur (après login direct ou après le code 2FA)
function enregistrerSessionCreateur(responseData) {
  const user = responseData.user || {};
  localStorage.setItem("token", responseData.token);
  if (user.photo_profil) localStorage.setItem("photo_profil", user.photo_profil);
  // ⚠️ CreateurModel utilise "nomComplet" (camelCase)
  if (user.nomComplet) localStorage.setItem("nomComplet", user.nomComplet);
}

export async function login({ email, password }) {
  const apiUrl = `${base_url}login/createur`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Client": "web", // 🔐 active la double authentification côté web (si TWOFA_ENABLED)
      },
      body: JSON.stringify({ email, password }),
    });

    const responseData = await response.json();

    if (!response.ok || !responseData.success) {
      return {
        success: false,
        message: responseData.message || "Échec de la connexion.",
      };
    }

    // 🔐 Double authentification : pas encore de token, il faut le code reçu par mail
    if (responseData.two_factor_required) {
      return {
        success: true,
        twoFactorRequired: true,
        challengeId: responseData.challenge_id,
        email: responseData.email,
        message: responseData.message,
      };
    }

    enregistrerSessionCreateur(responseData);

    return {
      success: true,
      token: responseData.token,
      utilisateur: responseData.user, // <-- map 'user' (backend) to 'utilisateur' (front)
      message: responseData.message,
    };
  } catch (error) {
    console.error("[LOGIN] error:", error);
    return {
      success: false,
      message: error.message || "Erreur inattendue lors de la connexion.",
    };
  }
}

// 🔐 Double authentification — vérifier le code reçu par mail
//    stocker = fonction qui enregistre la session (créateur par défaut)
export async function verifierCode2FA(challengeId, code, stocker = enregistrerSessionCreateur) {
  try {
    const response = await fetch(`${base_url}login/2fa/verify`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-Client": "web" },
      body: JSON.stringify({ challenge_id: challengeId, code }),
    });
    const data = await response.json().catch(() => ({}));

    if (!response.ok || !data.success) {
      return {
        success: false,
        code: data.code,                   // "incorrect" | "expire" | "trop_essais"
        essaisRestants: data.essais_restants,
        message: data.message || "Code incorrect.",
      };
    }

    stocker(data);
    return { success: true, token: data.token, utilisateur: data.user, role: data.role, message: data.message };
  } catch (error) {
    return { success: false, message: "Erreur de connexion au serveur." };
  }
}

// 🔐 Double authentification — renvoyer un nouveau code
export async function renvoyerCode2FA(challengeId) {
  try {
    const response = await fetch(`${base_url}login/2fa/resend`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-Client": "web" },
      body: JSON.stringify({ challenge_id: challengeId }),
    });
    const data = await response.json().catch(() => ({}));
    return {
      success: response.ok && !!data.success,
      attente: data.attente,
      code: data.code,
      message: data.message || (response.ok ? "Code renvoyé." : "Impossible de renvoyer le code."),
    };
  } catch (error) {
    return { success: false, message: "Erreur de connexion au serveur." };
  }
}


// services/LoginService.js
export async function register({
  nomComplet,
  email,
  password,
  telephone,
  siret = null,
  raison_sociale = null,
}) {
  const apiUrl = `${base_url}register/createur`; // endpoint pour createur

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        nomComplet,
        email,
        password,
        telephone,
        siret,
        raison_sociale,
      }),
    });

    const responseData = await response.json();
    //console.log("Response from Register Service:", responseData);

    if (!response.ok || !responseData.success) {
      return {
        success: false,
        message: responseData.message || "Échec de l'inscription.",
      };
    }

    // 👇 AJOUT — sauvegarde dès la création du compte
    const user = responseData.user || {};
    localStorage.setItem("token", responseData.token);
    if (user.photo_profil) localStorage.setItem("photo_profil", user.photo_profil);
    if (user.nomComplet) localStorage.setItem("nomComplet", user.nomComplet);

    return {
      success: true,
      message: responseData.message || "Inscription réussie ✅",
      token: responseData.token,
      utilisateur: responseData.user, // correspond au backend Laravel
    };
  } catch (error) {
    console.error("Erreur Register:", error);
    return {
      success: false,
      message: error.message || "Erreur inattendue lors de l'inscription.",
    };
  }
}



export async function createPaymentIntent(amount, plan, billing, token) {
  const apiUrl = `${base_url}paiement/create-intent`;

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ price: amount, plan, billing }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ message: 'Erreur serveur' }));
    throw new Error(err.message || 'Erreur création PaymentIntent');
  }

  return response.json(); // { success, client_secret, payment_intent_id, ... }
}
export async function confirmCheckoutSessionOnServer(sessionId, token) {
  const apiUrl = `${base_url}paiement/confirm`; // nouvel endpoint backend

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ session_id: sessionId }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({ message: 'Erreur serveur' }));
      throw new Error(err.message || 'Erreur confirmation Checkout Session');
    }

    const data = await response.json();
    console.log("Réponse backend confirmCheckoutSession:", data);
    return data;
  } catch (error) {
    console.error("Erreur confirmCheckoutSessionOnServer:", error.message);
    throw error;
  }
}



export async function freeSubscribe(plan, billing, token) {
  const apiUrl = `${base_url}paiement/free-subscribe`;

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ plan, billing }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ message: 'Erreur serveur' }));
    throw new Error(err.message || 'Erreur abonnement gratuit');
  }
  return response.json();
}

// Load your Stripe public key from .env

// Fonction pour récupérer le token depuis Redux
function getAuthHeaders(token) {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}
export async function tvainfo(token) {
  try {
    const response = await fetch(`${base_url}tvainfo`, {
      method: "POST",
      headers: getAuthHeaders(token),
    });

    const text = await response.text(); // récupère la réponse brute
    console.log("Réponse brute TVA Info:", text);

    const data = JSON.parse(text); // transforme en JSON
    if (!response.ok || !data.success) {
      console.error("Erreur TVA Info:", data);
      return { success: false, message: data.message || "Erreur récupération TVA info" };
    }

    // Renvoie uniquement les infos TVA
    return {
      success: true,
      tva_inclus: data.tva_inclus,
      tva_rates: data.tva_rates
    };
  } catch (error) {
    console.error("Catch TVA Info:", error);
    return { success: false, message: error.message };
  }
}


export async function ProfilInfo(token) {
  try {
    const response = await fetch(`${base_url}dashboard`, {
      method: "POST",
      headers: getAuthHeaders(token),
    });

    const text = await response.text(); // récupère la réponse brute
    console.log("Réponse brute Me:", text);

    const data = JSON.parse(text); // transforme en JSON

    if (!response.ok || !data.success) {
      console.error("Erreur Me:", data);
      return { success: false, message: data.message || "Erreur récupération profil" };
    }

    // Instancie le modèle UserModel pour gérer nulls et paiements
    const user = new UserModel({ ...data.user, paiements: data.paiements, comptable_status: data.comptable_status });

    return { success: true, user };
  } catch (error) {
    console.error("Catch Me:", error);
    return { success: false, message: error.message };
  }
}

export async function Me(token) {
  try {
    const response = await fetch(`${base_url}me`, {
      method: "POST",
      headers: getAuthHeaders(token),
    });

    const text = await response.text(); // récupère la réponse brute
    console.log("Réponse brute Me:", text);

    const data = JSON.parse(text); // transforme en JSON
    if (!response.ok || !data.success) {
      console.error("Erreur Me:", data);
      return { success: false, message: data.message || "Erreur récupération profil" };
    }

    return { success: true, user: data.user };
  } catch (error) {
    console.error("Catch Me:", error);
    return { success: false, message: error.message };
  }
}


// ✅ Se déconnecter
export async function Logout(token) {
  try {
    const response = await fetch(`${base_url}logout`, {
      method: "POST",
      headers: getAuthHeaders(token),
    });

    const data = await response.json();
    if (!response.ok) throw new Error("Erreur déconnexion");

    return { success: true, message: data.message };
  } catch (error) {
    return { success: false, message: error.message };
  }
}

// ✅ Rafraîchir le token
export async function Refresh(token) {
  try {
    const response = await fetch(`${base_url}refresh`, {
      method: "POST",
      headers: getAuthHeaders(token),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur refresh" };
    }

    return { success: true, token: data.token };
  } catch (error) {
    return { success: false, message: error.message };
  }
}


export async function UpdateProfile(token, formData) {
  if (!token) throw new Error("Utilisateur non authentifié");

  console.log("Objet reçu (avant envoi) :", formData);

  try {
    const response = await fetch(`${base_url}updateprofile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    });

    let data;
    try {
      data = await response.json();
    } catch (err) {
      console.error("Erreur parsing JSON :", err);
      throw new Error("Le serveur a renvoyé une réponse invalide");
    }

    if (!response.ok || !data.success) {
      const message = data?.message || "Erreur mise à jour profil";
      return { success: false, message };
    }

    // ⚡ Instanciation du modèle UserModel
    const user = new UserModel(data.user);

    return { success: true, user, message: data.message };
  } catch (error) {
    console.error("Erreur fetch UpdateProfile :", error);
    return { success: false, message: error.message };
  }
}

// ✅ Modifier le mot de passe
export async function UpdatePassword(token, ancienPassword, newPassword) {
  try {
    const response = await fetch(`${base_url}updatePassword`, {
      method: "POST",
      headers: getAuthHeaders(token),
      body: JSON.stringify({ ancienPassword, newPassword }),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur mise à jour mot de passe" };
    }

    return { success: true, message: data.message };
  } catch (error) {
    return { success: false, message: error.message };
  }
}
// ✅ Modifier le mot de passe
export async function Updaterib(token, rib) {
  try {
    const response = await fetch(`${base_url}updateinfo`, {
      method: "POST",
      headers: getAuthHeaders(token),
      body: JSON.stringify({ rib }),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur mise à jour mot de passe" };
    }

    return { success: true, message: data.message };
  } catch (error) {
    return { success: false, message: error.message };
  }
}
// ✅ Changer l'image de profil (multipart/form-data)
export async function ChangeImage(token, file) {
  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await fetch(`${base_url}changeimage`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`, // pas de content-type, sinon form-data cassé
      },
      body: formData,
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur changement d'image" };
    }

    return { success: true, imageUrl: data.imageUrl };
  } catch (error) {
    return { success: false, message: error.message };
  }
}



// ✅ Récupérer les statistiques avec filtre par dates
// ✅ Récupérer les statistiques avec filtre par dates
export async function getStatistics(token, dateDebut = null, dateFin = null) {
  try {
    const response = await fetch(`${base_url}getstatistics`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        date_debut: dateDebut,
        date_fin: dateFin,
      }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      return {
        success: false,
        message: data.message || "Erreur récupération statistiques",
      };
    }

    // 🔹 Retourne directement l'objet complet
    return { success: true, tva_inclus: data.tva_inclus, statistiques: data.statistiques };
  } catch (error) {
    return { success: false, message: error.message };
  }
}

export async function tvaMensuelle(token, dateDebut, dateFin) {
  try {
    const response = await fetch(`${base_url}tvamensuelle`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        date_debut: dateDebut,
        date_fin: dateFin,
      }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur récupération TVA" };
    }

    return {
      success: true,
      tva_par_taux: data.tva_par_taux || {},
      tva_user: data.tva_user || {},
      totaux_tva: data.totaux_tva || 0,
    };
  } catch (error) {
    return { success: false, message: error.message };
  }
}




// Récupérer les revenus par mois pour une année donnée
export async function getRevenusParMois(token, year) {
  try {
    const response = await fetch(`${base_url}revenusparmois`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ year }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur récupération revenus" };
    }

    return { success: true, revenus: data.revenus };
  } catch (error) {
    return { success: false, message: error.message };
  }
}

// Récupérer les revenus par mois pour une année donnée
export async function getCamembert(token) {
  try {
    const response = await fetch(`${base_url}camembert`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur récupération revenus" };
    }

    // renvoie exactement les clés que ton front attend
    return {
      success: true,
      revenu_batiment: data.revenu_batiment || {},
      revenu_autres: data.revenu_autres || {},
    };
  } catch (error) {
    return { success: false, message: "Erreur: Actualiser la page" };
  }
}


// ✅ Récupérer l'abonnement de l'utilisateur
export async function getAbonnement(token) {
  try {
    const response = await fetch(`${base_url}abonnement`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      return { success: false, message: data.message || "Erreur récupération abonnement" };
    }

    return { success: true, abonnement: data.abonnement };
  } catch (error) {
    return { success: false, message: error.message };
  }
}


//Comptable

// Comptable
export async function envoyercomptable(email_comptable, token) {
  const apiUrl = `${base_url}envoyercomptable`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,

      },
      body: JSON.stringify({ email_comptable }),
    });

    const responseData = await response.json();

    if (!response.ok || !responseData.success) {
      return {
        success: false,
        message: responseData.message || "Échec de l'envoi de l'invitation.",
      };
    }

    return {
      success: true,
      message: responseData.message || "Invitation envoyée avec succès.",
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || "Erreur inattendue lors de l'envoi.",
    };
  }
}

// Contact
export const contact = async (formData) => {
  try {
    const response = await fetch(`${base_url}sendEmail`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    return await response.json();
  } catch (error) {
    return { success: false, message: "Erreur de connexion au serveur." };
  }
};


// Contact
export const deletecompte = async (email, password) => {
  try {
    const response = await fetch(`${base_url}deletecompte`, {
      method: "delete",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, password: password }),
    });

    return await response.json();
  } catch (error) {
    return { success: false, message: "Erreur de connexion au serveur." };
  }
};


//changer password pour  le mot de passe oublié du application flutter client
export const resetPassword = async (data) => {
  const response = await fetch(`${base_url}reset-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  });

  return await response.json();
};